export default "/images/725b3430d8d526bbb38f79f9a5e63333.avif";